export default "__VITE_ASSET__DRq_VUzn__"